import React from 'react';
import { createRoot } from 'react-dom/client';
import { createStore } from 'redux';
import { Provider } from 'react-redux'
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './index.scss';
import App from './App';
import { rootReducer } from './store'
import arxeiaConfigurationsService from '../src/services/arxeiaConfigurations.service';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { initializeMsalInstance } from "./auth/msal-instance";
import { InteractionType } from '@azure/msal-browser';



const store = createStore(
    rootReducer,
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__()
);

arxeiaConfigurationsService.getFEConfigurations()
    .then(async (configurations) => {
        window.sessionStorage.setItem("clientId", configurations.clientId);
        window.sessionStorage.setItem("tenantId", configurations.tenantId);
        window.sessionStorage.setItem("apiClientId", configurations.apiClientId);
        window.sessionStorage.setItem("packageVersion", configurations.packageVersion);

        const msalInstance = await initializeMsalInstance(configurations.clientId, configurations.tenantId);

        // AK note: In case there is problem with process after token expires try to adapt the code to this point: https://learn.microsoft.com/en-us/entra/identity-platform/scenario-spa-acquire-token?tabs=react
        // I tried to put that on the App.tsx file exactly like that but I had the issue that the token was gotten after layout was intiialized and first api calls were done without token so it failed.
        // Check state at commit 552e63e0 at 12/03/2025

        const container = document.getElementById("root");
        const root = createRoot(container!);

        root.render(
            <MsalProvider instance={msalInstance}>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                    <Provider store={store}>
                        <App />
                    </Provider>
                </MsalAuthenticationTemplate>
            </MsalProvider>
        );
    }).catch(error => {
        console.log(error);
        console.log('Api for configurations is not available');
    });


export { store };


